<template>
<div class="container">
    <h3>Listado de Análisis: {{nombrecliente}}</h3>
    <div class="text-left">
        <button class="btn btn-primary" @click.prevent="irAnalisis">+Agregar</button>
    </div>
    <div>

        <table class="table table-hover">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Fecha</th>
                    <th>Tamaño Planta</th>
                    <th>Valor dólar</th>
                    <th>Valor ecer</th>
                    <th>Valor Planta</th>
                    <th>tasa/cuotas/pie/</th>
                    <th>Ver</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(analisis, index) in traerDataAnalisis" :key="index">
                    <th>{{index+1}}</th>
                    <td>{{analisis.fecha }} </td>
                    <td>{{analisis.tamanoplantacotizar}}</td>
                    <td>{{analisis.valordolarcotizar}}</td>
                    <td>{{analisis.valorecer}}</td>
                    <td>{{analisis.tamanoplantacotizar *1000 * analisis.valordolarcotizar * analisis.valorecer | formato }}</td>
                    <td>{{analisis.tasa}}% {{analisis.plazoanos *12}} {{analisis.pie}}%</td>
                    <td><button @click.prevent="verAnalisis(index, analisis.idCliente, analisis.idDoc)">+</button></td>
                </tr>
            </tbody>
        </table>

    </div>

</div>
</template>

<script>
export default {
    name: 'Listadoanalisis',
    data() {
        return {
            nombrecliente: this.$store.getters.enviarDataClientes[this.$route.params.id].nombre
        }
    },
    computed: {
        traerDataAnalisis() {
            return this.$store.getters.enviarDataAnalisis;
        },

    },
    mounted() {

    },
    methods: {
        irAnalisis() {
            this.$router.push(`/analisis/${this.$route.params.id}`)
        },
        verAnalisis(index, idCliente, idDocAnalisis) {
            this.$store.dispatch('pasarIdCliente', idCliente); // dispara almacenar datos del cliente especifico para montar en el veranalisis
            let auxiliar = {
                idCliente: idCliente,
                idDocAnalisis: idDocAnalisis
            }
            this.$store.dispatch('AnalisisDataAnalisis', auxiliar);
            this.$router.push(`/veranalisis/${index}`)

        },
        buscarDataAnalisis() {
            alert("hola");
        }

    }
}
</script>

<style>

</style>
